import forEach from "@homer.utility/foreach";

class Node {
    constructor(language) {
        const node = document.createElement("link");

        node.setAttribute("rel", "alternate");
        node.setAttribute("hrefLang", language);

        return node;
    }
}

export default class Language {
    #node = new Map();
    #current = {};

    constructor(nodes) {
        forEach(nodes, (node) => {
            this.#node.set(node.getAttribute("hrefLang"), node);
            this.#current[node.getAttribute("hrefLang")] = node.getAttribute("href");
        });

        this.update(this.#current);
    }

    get current() {
        return this.#current;
    }

    update(languages) {
        this.#current = languages;

        forEach(languages, (url, language) => {
            const node = this.#node.get(language) || this.#node.set(language, new Node(language)).get(language);

            node.setAttribute("href", url);
        });

        this.#node.forEach((node, language) => {
            if (!languages[language] && node.isConnected) {
                node.parentNode.removeChild(node);

                return;
            }

            if (!node.isConnected) {
                document.head.appendChild(node);
            }
        });
    }
}
